// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.analytic_biogenic_amines_kind_enum */
var AnalyticBiogenicAminesKindEnum;
(function (AnalyticBiogenicAminesKindEnum) {
    AnalyticBiogenicAminesKindEnum["total"] = "total";
    AnalyticBiogenicAminesKindEnum["extracellular"] = "extracellular";
})(AnalyticBiogenicAminesKindEnum || (AnalyticBiogenicAminesKindEnum = {}));
;
export default AnalyticBiogenicAminesKindEnum;
/** Zod schema for analytic_biogenic_amines_kind_enum */
export const analyticBiogenicAminesKindEnum = z.nativeEnum(AnalyticBiogenicAminesKindEnum);
//# sourceMappingURL=AnalyticBiogenicAminesKindEnum.js.map